import _ from 'lodash'

const getEnv = () => {
  console.log(process.env)
  // 预发布会在全局下毒，加 window.MW_ENV.NODE_ENV 环境变量
  return _.get(window, 'MW_ENV.NODE_ENV') || process.env.NODE_ENV
}

export const NODE_ENV = getEnv()
export const GO_BASE_API = process.env.GO_BASE_API
export const BASE_API = process.env.BASE_API
export const TAG = process.env.TAG

export const isProduction = NODE_ENV === 'production'
export const isDevelopment = NODE_ENV === 'development'
export const isPrerelease = NODE_ENV === 'prerelease'
export const isTest = NODE_ENV === 'test'
